export const FIND_FILES_REQUEST = 'FIND_FILES_REQUEST';

export const findFilesRequest = ({
     filter = [],
     sorting = { field: 'originalname', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_FILES_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
